import { HttpClient, HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Platform } from '@ionic/angular';
import { from, Observable, ReplaySubject } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { Environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class StrapiAuthInterceptor implements HttpInterceptor {
  amplifyAppService: AuthService;
  platform: Platform;

  constructor(inj: Injector) {
    this.amplifyAppService = inj.get(AuthService);
    this.platform = inj.get(Platform);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (request.url.startsWith(Environment.CONTENT_URL)) {
      return from(this.amplifyAppService.getCurrentSession())
        .pipe(
          mergeMap(tokens => {
            const headers = {
              Authorization: `Bearer ${tokens['idToken'].jwtToken}`
            };

            request = request.clone({
              setHeaders: headers
            });

            return next.handle(request);
          }),
          catchError(error => {
            if (!(error instanceof HttpErrorResponse)) {
              console.error(error);
            }

            // If no user is present procedd with request
            return next.handle(request);
          }
        )
      );
    } else {
      return next.handle(request);
    }
  }
}
